module.exports = __webpack_public_path__ + "img/logo-header.85273b82.svg";